import type { Validation } from "@/lib/validation"
import { isArray } from "@/lib/validation/isArray"
import { isExpectation } from "@/lib/validation/isExpectation"

export const isExpectationArray = <
  Registry extends Validation.BaseRegistry,
  Subject
>(
  api: Validation.API<Registry>,
  expectation: unknown,
  warn?: boolean
): expectation is Validation.ExpectationArray<Registry, Subject> => {
  if (!isArray(expectation)) {
    if (warn && api.debugEnabled()) {
      api.privateFunctions.debug(
        `Validation#isExpectationArray expected an array but got:`,
        {
          expectation,
        }
      )
    }

    return false
  }

  const failures: { index: number; value: unknown }[] = []

  expectation.forEach((value, index) => {
    if (value === undefined) {
      return
    }

    if (value === null) {
      return
    }

    if (!isExpectation(api, value, warn)) {
      failures.push({ index, value })
    }
  })

  if (failures.length === 0) {
    return true
  }

  if (warn && api.debugEnabled()) {
    api.privateFunctions.debug(
      `Validation#isExpectation found invalid expectation array:`,
      {
        expectation,
        failures,
      }
    )
  }

  return false
}
